<template>
  <v-popup class="vbuy-end" :zIndex="4000" v-model="show" position="bottom" :close-on-click-overlay="false">
    <div class="vbuy-end-wrap">
      <div class="result">
        <!-- 0 成功， 1 活动结束， 2 活动库存不足， 3 其他失败情况， 4 常规库存不足 -->
        <template v-if="isAtmosphere === 0 && marketable && vBuyStatus != 4">
          <img src="../img/end.png" alt="" class="result-img" />
          <p class="result-desc">您心仪的商品价格有变动</p>
        </template>
        <template v-else-if="vBuyStatus == 2 || vBuyStatus == 4">
          <img src="../img/empty.png" alt="" class="result-img" />
          <p class="result-desc">活动太火爆了，商品已被抢光了</p>
        </template>
        <template v-else>
          <img src="../img/end.png" alt="" class="result-img" />
          <p class="result-desc">很抱歉，活动已结束</p>
        </template>
      </div>
      <div class="vbuy-hot-box" v-if="actSkus && actSkus.length">
        <div class="tit"><span class="name">其他热门活动商品</span></div>
        <div class="vbuy-list">
          <a class="item btn-custom" :href="item.prodUrl" v-for="(item, index) in otherActList" :key="index">
            <div class="pic">
              <img v-lazy="item.skuImgUrl" alt="" />
            </div>
            <div class="info">
              <div class="name word-nowrap">{{ item.prodName }}</div>
              <div class="price-box">
                活动价：
                <strong class="current-price">
                  <span class="yen">&yen;</span>
                  {{ item.actPrice | formatNumber }}
                </strong>
                <span class="original-price" v-if="item.actPrice < item.marketPrice">
                  <span class="yen">&yen;</span>
                  {{ item.marketPrice | formatNumber }}
                </span>
              </div>
              <div :class="['status', { doing: item.actState == 1 }]">
                <span class="txt">
                  <template v-if="item.actState == 1">抢购进行中</template>
                  <template v-if="item.actState == 2">即将开始</template>
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="btns">
        <v-button type="link" position="center" textColor="#f10313" v-if="isAtmosphere === 0" @click="viewhome">
          {{ marketable && vBuyStatus != 4 ? '确定' : '返回首页' }}
        </v-button>
        <template v-else>
          <v-button v-if="marketable && vBuyStatus != 4" @click="buyProduct" position="center" type="frame-plus">原价购买</v-button>
          <v-button position="center" type="cancel" @click="otherAct">查看其它活动</v-button>
        </template>
      </div>
    </div>
  </v-popup>
</template>

<script>
import config from 'config'

export default {
  name: 'vbuy-end-popup',
  props: {
    // 其他热门活动
    actSkus: Array,
    // 是否有库存
    vBuyStatus: Number,
    skuInfo: Object,
    commonBuy: Function,
    marketable: Boolean
  },
  computed: {
    isAtmosphere() {
      return this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.isAtmosphere
    },
    otherActList() {
      return this.actSkus?.slice(0, 3)
    }
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    /**
     * 跳转其他热门活动
     */
    otherAct() {
      let src =
        this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityQuickBuy?.actUrl || config.path.shopUrl
      this.show = false
      window.location.href = src
    },

    viewhome() {
      if (this.marketable && this.vBuyStatus != 4) {
        window.location.reload()
      } else {
        window.location.href = '//shop.vivo.com.cn/wap/'
      }
    },

    /**
     * 原价购买
     */
    buyProduct() {
      this.commonBuy()
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
